import { useSnackbar, WBAlert, WBLinkButton } from '@admiin-com/ds-web';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export interface ErrorHandlerProps {
  errorMessage?: string;
  isDialog?: boolean;
  onOpenNewDialog?: () => void;
}

export const ErrorHandler = ({
  errorMessage,
  onOpenNewDialog,
  isDialog,
}: ErrorHandlerProps) => {
  const { t } = useTranslation();
  const showSnackbar = useSnackbar();

  useEffect(() => {
    if (isDialog && errorMessage) {
      showSnackbar({
        message: t(errorMessage, { ns: 'errors' }),
        severity: 'error',
      });
    }
  }, [errorMessage, isDialog, showSnackbar]);

  return (
    errorMessage &&
    !isDialog && (
      <WBAlert
        title={t(errorMessage, { ns: 'errors' })}
        severity="error"
        sx={{ my: 2 }}
      >
        {/* {errorMessage} */}
        {errorMessage === 'ENTITY_NOT_VERIFIED' && (
          <WBLinkButton
            onClick={() => {
              if (onOpenNewDialog) {
                onOpenNewDialog();
              }
            }}
            sx={{
              textDecoration: 'underline',
            }}
          >
            Verify Now
          </WBLinkButton>
        )}
      </WBAlert>
    )
  );
};

export default ErrorHandler;
